import Widget from "lib/widget";
import AjaxFileForm from "servos/ajaxFileForm";
import { initBootstrapComponents } from "lib/bootstrapTooltips";

class inlineDocumentUpload extends Widget {
  bind() {
    bindAjaxForm.call(this)
    bindDragAndDrop.call(this)
  }
}

let bindAjaxForm = function () {
  this.ajaxForm = new AjaxFileForm(this.root.find('form'))
  this.ajaxForm.on('success', success.bind(this))
  this.ajaxForm.on("error", errorResponse.bind(this))

  this.root.on('change', 'input', (e) => {
    this.root.find('form').submit()
    this.root.find('.inline-upload-form').addClass('d-none')
    this.root.find('.form-spinner').removeClass('d-none')
  })
};

// Bound once for the whole page, not per row. Only adds event listeners once via dragAndDropBound guard.
let dragAndDropBound = false

let bindDragAndDrop = function () {
  if (dragAndDropBound) return
  dragAndDropBound = true

  const HIGHLIGHT_TIMEOUT = 400
  let activeRow = null
  let activeTimeout = null

  const rowUnderCursor = (e) => {
    const el = document.elementFromPoint(e.originalEvent.clientX, e.originalEvent.clientY)
    const row = el && $(el).closest('.checklist-item')
    // Return null if no row is there or if the row already has a document, so it is not a valid drop target.
    return row && row.find('input[type="file"]').length ? row : null
  }

  const clearActiveRow = () => {
    if (!activeRow) return
    clearTimeout(activeTimeout)
    activeRow.removeClass('is-dragover')
    activeRow = null
  }


  $(document).on('dragenter dragover', (e) => {
    // preventDefault runs even with no row under the cursor so a stray drop anywhere on the
    // page doesn't fall through to the browser's default (navigating to show the raw file).
    e.preventDefault()

    const row = rowUnderCursor(e)
    // If no row is under the cursor or if the cursor is over a different row than the active row, clear the active row.
    if (!row) return clearActiveRow()
    if (activeRow && activeRow[0] !== row[0]) clearActiveRow()

    activeRow = row
    row.addClass('is-dragover')
    // Set a timeout to clear the highlight if the drag ends without a matching event on this
    // page (e.g. dropped outside the browser), since nothing else would ever clear it.
    clearTimeout(activeTimeout)
    activeTimeout = setTimeout(clearActiveRow, HIGHLIGHT_TIMEOUT)
  })

  $(document).on('drop', (e) => {
    e.preventDefault()
    const row = rowUnderCursor(e)
    clearActiveRow()
    if (!row) return

    const files = e.originalEvent.dataTransfer.files
    if (!files.length) return

    const input = row.find('input[type="file"]')[0]
    const transfer = new DataTransfer()
    Array.from(files).forEach((file) => transfer.items.add(file))
    input.files = transfer.files

    $(input).trigger('change')
  })
};

let success = function (response) {
  updateItemRow.call(this, response)
}

// update item row
let updateItemRow = function (response) {
  const itemId = response.data.item.id;
  this.root.replaceWith(response.data.item.html);
  const newRow = document.querySelector(`.checklist-item[data-item-id="${itemId}"]`);
  if (newRow) initBootstrapComponents(newRow);
  this.emit('item-updated', {
    outstanding_general_badge: response.data.project.outstanding_general_badge,
    checklist_labels: response.data.project.checklist_labels
  })
  // this.root.find('#general-badge').html(response.data.project.outstanding_general_badge)
  // this.root.find('#project-checklist-labels').html(response.data.project.checklist_labels)
}

// this widget is shared with the external pages.
// For external pages we don't pass the url but the item id instead.
let getOrBuildUrl = function (e) {
  if (e.currentTarget.dataset.url != undefined) {
    return e.currentTarget.dataset.url
  } else {
    return `${gon.base_namespace}/checklist_items/${e.currentTarget.dataset.itemId}/document_modal`
  }
}

let errorResponse = function (response) {
  swal({
    html: "File type not valid, supported files are: jpg jpeg gif png pdf doc docx",
    type: "warning"
  }).then((confirm) => {
    this.root.find('.form-spinner').addClass('d-none')
    this.root.find('.inline-upload-form').removeClass('d-none')
  })
}

export default inlineDocumentUpload
